import { type RefObject, useEffect, useRef } from "react";

/** Listen for a Forge custom event on a ref'd element. Forge events are kebab-case and bubble. */
export function useForgeEvent<E extends Event = CustomEvent>(
  ref: RefObject<HTMLElement | null>,
  name: string,
  handler: (e: E) => void,
) {
  const latest = useRef(handler);
  latest.current = handler;
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const fn = (e: Event) => latest.current(e as E);
    el.addEventListener(name, fn);
    return () => el.removeEventListener(name, fn);
  }, [ref, name]);
}
